import React, { useState, useEffect } from "react";
import { handleError, handleSuccess } from "../../Utils";
import {
  bhopalFirstEventData,
  registerForEvent,
} from "../../ApiServices/ApiServices";
import {useNavigate} from 'react-router-dom';
import SuccessMessage from "./FormSuccessMessage";

const BhopalEventForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [course, setCourse] = useState("");
  const [branch, setBranch] = useState("");
  const [batch, setBatch] = useState("");
  const [semester, setSemester] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigateTo = useNavigate();
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState(false);

  const fetchBhopalFirstEventData = async () => {
    try {
      const res = await bhopalFirstEventData();
      setName(res?.data?.name);
      setEmail(res?.data?.email);
      setPhone(res?.data?.phone);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchBhopalFirstEventData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      const data = {
        name,
        email,
        phone,
        collegeName,
        course,
        branch,
        batch,
        semester,
        rollNo,
      };
      const res = await registerForEvent(data);
      // handleSuccess(res?.message);
      setConfirmationDialog(true);
      setConfirmationMessage(res?.message)
      setName("");
      setEmail("");
      setPhone("");
      setCollegeName("");
      setCourse("");
      setBranch("");
      setBatch("");
      setSemester("");
      setRollNo("");
      // setTimeout(() => {
      //   navigateTo("/dashboard/home")
      // }, 2000);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }finally{
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-6"
      style={{
        backgroundImage:
          "url('https://intlpagasia.org/2025/storage/2018/11/speaker-photos-1-1130x650.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-blue-900 bg-opacity-60 z-0"></div>
      {confirmationDialog && (<SuccessMessage message={"Form submitted successfully!"}/>)}
      <form
        onSubmit={handleSubmit}
        className="relative z-10 bg-white p-8 rounded-2xl shadow-xl w-full max-w-2xl mt-16"
      >
        <h2 className="text-3xl font-bold text-center mb-6 text-blue-700">
          Registration For Contest
        </h2>

        <div className="text-center my-40 text-red-500">Registration have been closed!</div>

        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="Full Name"
            className={inputClass}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled
          />
          
          <input
            type="tel"
            placeholder="Phone Number"
            className={inputClass}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            disabled
          />
          <input
            type="text"
            placeholder="College Name"
            className={inputClass}
            value={collegeName}
            onChange={(e) => setCollegeName(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Enrollment No."
            className={inputClass}
            value={rollNo}
            onChange={(e) => setRollNo(e.target.value)}
            required
          />

          <select
            className={inputClass}
            value={course}
            onChange={(e) => setCourse(e.target.value)}
            required
          >
            <option value="">Course</option>
            <option value="B-Tech">B-Tech</option>
            <option value="M-Tech">M-Tech</option>
            <option value="MBA">MBA</option>
            <option value="BBA">BBA</option>
            <option value="BSC">BSC</option>
            <option value="B-Com">B-Com</option>
            <option value="Other">Other</option>
          </select>

          <select
            className={inputClass}
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
            required
          >
            <option value="">Branch</option>
            <option value="CS">CS</option>
            <option value="IT">IT</option>
            <option value="ECE">ECE</option>
            <option value="EX">EX</option>
            <option value="EE">EE</option>
            <option value="AI/ML">AI/ML</option>
            <option value="CE">CE</option>
            <option value="ME">ME</option>
            <option value="Other">Other</option>
          </select>

          <select
            className={inputClass}
            value={batch}
            onChange={(e) => setBatch(e.target.value)}
            required
          >
            <option value="">Batch</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
          </select>

          <select
            className={inputClass}
            value={semester}
            onChange={(e) => setSemester(e.target.value)}
            required
          >
            <option value="">Semester</option>
            {[...Array(8)].map((_, i) => (
              <option key={i + 1} value={`${i + 1}`}>
                {i + 1} Semester
              </option>
            ))}
          </select>
        </div> */}

        {/* <button
          type="submit"
          disabled={isSubmitting}
          className={`mt-6 w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl transition ${isSubmitting?"cursor-not-allowed":""}`}
        >
          Submit Registration
        </button> */}
      </form>
    </div>
  );
};

const inputClass =
  "w-full p-3 border border-blue-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500";

export default BhopalEventForm;
